/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    subsidyId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    subsidyDetailId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    relationship?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    degreeCount?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    ageType?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    priceType?: string;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    useDates?: Array<JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDate>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    groupId?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation
     */
    amount?: number;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subsidyId': !exists(json, 'subsidyId') ? undefined : json['subsidyId'],
        'subsidyDetailId': !exists(json, 'subsidyDetailId') ? undefined : json['subsidyDetailId'],
        'relationship': !exists(json, 'relationship') ? undefined : json['relationship'],
        'degreeCount': !exists(json, 'degreeCount') ? undefined : json['degreeCount'],
        'ageType': !exists(json, 'ageType') ? undefined : json['ageType'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'useDates': !exists(json, 'useDates') ? undefined : ((json['useDates'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateFromJSON)),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subsidyId': value.subsidyId,
        'subsidyDetailId': value.subsidyDetailId,
        'relationship': value.relationship,
        'degreeCount': value.degreeCount,
        'ageType': value.ageType,
        'priceType': value.priceType,
        'useDates': value.useDates === undefined ? undefined : ((value.useDates as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseSubsidyReservationUseDateToJSON)),
        'groupId': value.groupId,
        'amount': value.amount,
    };
}

